module.exports = __webpack_public_path__ + "img/like_red.8b71f781.png";